import { render, staticRenderFns } from "./StandsConfirm.vue?vue&type=template&id=41affb70"
import script from "./StandsConfirm.vue?vue&type=script&lang=js"
export * from "./StandsConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports